import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const authApi = axios.create({ baseURL: API, withCredentials: true });

const SESSION_FLAG = "n3_session";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await authApi.get("/auth/me");
      setUser(res.data);
      try { localStorage.setItem(SESSION_FLAG, "1"); } catch (e) { /* ignore */ }
    } catch (e) {
      setUser(null);
      try { localStorage.removeItem(SESSION_FLAG); } catch (err) { /* ignore */ }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    // Only probe the session when the user has previously signed in. This keeps
    // public pages free of 401 console noise for anonymous enterprise visitors.
    let hasFlag = false;
    try { hasFlag = localStorage.getItem(SESSION_FLAG) === "1"; } catch (e) { /* ignore */ }
    if (!hasFlag) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try { await authApi.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(null);
    try { localStorage.removeItem(SESSION_FLAG); } catch (e) { /* ignore */ }
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}

export function login() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/investor/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
